import SnackBarUtils from '@src/components/shared/SnackBarUtils';

type IRedirectArgs = {
    hierarchy: string;
    node?: string;
};

export async function redirect({ hierarchy, node }: IRedirectArgs) {
    const toastInfoKey = SnackBarUtils.info('Redirecting...');
    const reqCtrl = getReqCtrl();

    try {
        const response = await fetch('/api/redirect-link', {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify({
                hierarchy,
                node,
            }),
            signal: reqCtrl.signal,
        });

        if (!response.ok) {
            throw new Error(`Redirect link request failed with status ${response.status}`);
        }

        const res = await response.json();

        window.open(res.path, '_blank');
    } catch (err) {
        if (err instanceof DOMException && err.name === 'AbortError') {
            // request was intentionally aborted, no need to show an error
            return;
        }
        // eslint-disable-next-line no-console
        console.error(err);
        SnackBarUtils.error('Failed to redirect!');
    } finally {
        SnackBarUtils.close(toastInfoKey);
    }
}

//  used to cancel previous requests before starting a new one
let lastAbortCtrl: AbortController | null = null;
function getReqCtrl() {
    if (lastAbortCtrl) lastAbortCtrl.abort();

    const ctrl = new AbortController();
    lastAbortCtrl = ctrl;

    return ctrl;
}
